import { render, staticRenderFns } from "./ReportPayReceiveDocs.vue?vue&type=template&id=ae7b688c&"
import script from "./ReportPayReceiveDocs.vue?vue&type=script&lang=js&"
export * from "./ReportPayReceiveDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports